import { styled } from "styled-components";

export const Title = styled.div`
  padding: 24px 0 24px 0;
  display: flex;
  font-size: 24px;
  font-weight: 600;
`;
